import { mount } from 'svelte';

import App from './App.svelte';

const app = mount(App, {
  target: document.getElementById('resi-static__app') as HTMLElement,
});

export default app;
